import React, { useState } from "react";
import classNames from "classnames";
import Chevron from "assets/icons/glory/chevronUp.svg?react";
import { loyaltyHelpFaqData } from "./data";
import useTranslate from "../../../hooks/useTranslate";
import "./styles.sass";

const LoyaltyHelpFaq: React.FC = () => {
  const [openIndexes, setOpenIndexes] = useState<Set<number>>(new Set());
  const t = useTranslate();

  const toggleItem = (index: number) => {
    setOpenIndexes((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const chevronClassname = (open: boolean) =>
    classNames("loyaltyHelpTerms__icon", open && "loyaltyHelpTerms__icon_open");

  return (
    <div className="loyaltyHelpFaq">
      <div className="loyaltyHelpFaq__title">{t("loyatly.faq")}</div>
      <div className="loyaltyHelpFaq__list">
        {loyaltyHelpFaqData.map((item, index) => (
          <div className="loyaltyHelpFaq__item" key={item.title}>
            <div
              className="loyaltyHelpFaq__item-wrapper"
              onClick={() => toggleItem(index)}
            >
              <div className="loyaltyHelpFaq__item-title">{t(item.title)}</div>
              <Chevron className={chevronClassname(openIndexes.has(index))} />
            </div>
            {openIndexes.has(index) && (
              <div className="loyaltyHelpFaq__item-text">{t(item.content)}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoyaltyHelpFaq;
